import { Box, Button, Container, Typography } from '@mui/material';

const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <Box       
    className="site-footer"
    component="footer" sx={{
      borderTop: '2px solid',
      borderColor: '#111',
      mt: 6,
      py: 3,
      backgroundColor: 'transparent',
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" sx={{ color: 'text.primary', fontSize: 14 }}>
            © {year} Monno
          </Typography>
          <Button
            component="a"
            href="mailto:hi@stuarthenderson.co.uk"
            variant="outlined"
            color="inherit"
            sx={{ textTransform: 'none', borderRadius: 0 }}
          >
            Contact
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default SiteFooter;
